import React from 'react'
import { changeScreen, changeScreenB, changeScreenC } from '../../../store/actions/navigation.action'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer } from '@material-ui/core'
import ActionsEdit from '../actions/edit'
import Raffle from '../actions/raffle'
import Metrics from '../metrics'
import Transactions from '../transactions'
import Consult from '../consult'
import Shopping from '../shopping'

const style = {
    width: '680px',
    maxWidth: window.innerWidth
}

export default function Navigation(props) {
    const dispatch = useDispatch()
    const nav = useSelector(state => state.navigationReducer)

    return (
        <>
            <Drawer 
                anchor="right"
                open={nav.screen.open}
                onClose={() => dispatch(changeScreen({ open: false }))}
            >
                <div className="max-width" style={style}>
                    {(nav.screen.type === 'action-edit' || nav.screen.type === 'action-create') &&
                        <ActionsEdit 
                            uid={nav.screen.props.uid}
                        />
                    }
                    {(nav.screen.type === 'raffle') &&
                        <Raffle 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'search-cota') &&
                        <Consult 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'shopping') &&
                        <Shopping
                            screen="a"
                            user_id={nav.screen.props.user_id}
                        />
                    }

                    {(nav.screen.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screen.props.uid}
                        />
                    }

                    {(nav.screen.type === 'transactions') &&
                        <Transactions 
                            uid={nav.screen.props.uid}
                        />
                    }
                </div>
            </Drawer>

            <Drawer 
                anchor="right"
                open={nav.screenB.open}
                onClose={() => dispatch(changeScreenB({ open: false }))}
            >
                <div className="max-width" style={style}>

                    {(nav.screenB.type === 'shopping') &&
                        <Shopping
                            screen="b"
                            user_id={nav.screenB.props.user_id}
                        />
                    }

                    {(nav.screenB.type === 'metrics') &&
                        <Metrics 
                            uid={nav.screenB.props.uid}
                            link_id={nav.screenB.props.link_id}
                        />
                    }

                    {(nav.screenB.type === 'transactions') &&
                        <Transactions 
                            uid={nav.screenB.props.uid}
                            user_id={nav.screenB.props.user_id}
                            link_id={nav.screenB.props.link_id}
                        />
                    }
                </div>
            </Drawer>

            <Drawer 
                anchor="right"
                open={nav.screenC.open}
                onClose={() => dispatch(changeScreenC({ open: false }))}
            >
                <div className="max-width" style={style}>
                    {(nav.screenC.type === 'transactions') &&
                        <Transactions
                            screen="c"
                            uid={nav.screenC.props.uid}
                            user_id={nav.screenC.props.user_id}
                            link_id={nav.screenC.props.link_id}
                        />
                    }
                </div>
            </Drawer>
        </>
    )
}